var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchCategoryInternetOfThings16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/16/Internet-of-Things_16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Internet-of-Things_16.svg"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B660F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CAE3E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/16/Internet-of-Things_16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Internet-of-Things_16.svg)",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-13",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/16/IoT_16",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,8 C13.448,8 13,7.551 13,7 C13,6.449 13.448,6 14,6 C14.552,6 15,6.449 15,7 C15,7.551 14.552,8 14,8 M11,12.38 L11,7.5 L12.071,7.5 C12.274,8.284 12.938,8.875 13.759,8.976 C13.343,10.481 12.333,11.695 11,12.38 M9,12.955 L9,3.929 C9.591,3.775 10.075,3.363 10.322,2.816 C11.521,3.24 12.55,4.076 13.209,5.165 C12.648,5.407 12.227,5.9 12.071,6.5 L10.5,6.5 C10.224,6.5 10,6.724 10,7 L10,12.771 C9.677,12.863 9.344,12.924 9,12.955 M7,12.774 L7,7 C7,6.724 6.776,6.5 6.5,6.5 L4.929,6.5 C4.773,5.9 4.352,5.407 3.791,5.165 C4.45,4.076 5.479,3.24 6.678,2.816 C6.925,3.363 7.409,3.775 8,3.929 L8,12.956 C7.656,12.925 7.323,12.865 7,12.774 M3.203,8.979 C4.04,8.894 4.722,8.296 4.929,7.5 L6,7.5 L6,12.389 C4.649,11.706 3.625,10.49 3.203,8.979 M3,6 C3.552,6 4,6.449 4,7 C4,7.551 3.552,8 3,8 C2.448,8 2,7.551 2,7 C2,6.449 2.448,6 3,6 M8.5,1 C9.052,1 9.5,1.449 9.5,2 C9.5,2.551 9.052,3 8.5,3 C7.948,3 7.5,2.551 7.5,2 C7.5,1.449 7.948,1 8.5,1 M14.27,5.027 C13.482,3.506 12.109,2.343 10.481,1.819 C10.389,0.802 9.541,0 8.5,0 C7.459,0 6.611,0.802 6.519,1.819 C4.891,2.343 3.518,3.506 2.73,5.027 C1.756,5.161 1,5.989 1,7 C1,7.787 1.461,8.462 2.123,8.789 C2.562,10.959 4.043,12.683 6,13.491 L6,15.5 L7,15.5 L7,13.807 C7.325,13.883 7.659,13.93 8,13.956 L8,15.5 L9,15.5 L9,13.956 C9.342,13.929 9.675,13.882 10,13.805 L10,15.5 L11,15.5 L11,13.484 C12.93,12.677 14.389,10.967 14.829,8.814 C15.518,8.498 16,7.806 16,7 C16,5.989 15.244,5.161 14.27,5.027",
    id: "IoT_Category-Icon_16_Squid--"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryInternetOfThings16);
export default __webpack_public_path__ + "static/media/Arch-Category_Internet-of-Things_16.22a85dab6bab69054d311258a5425b3f.svg";
export { ForwardRef as ReactComponent };